<template>
  <div class="star-evaluation" :class="{ checkapp: platform === 'checkapp' }">
    <section class="star-evaluation-box">
      <!-- <section class="chat-info">
        <div v-show="skillName" class="skill-name">
          技能组名称：
          <span>{{ skillName }}</span>
        </div>
        <div class="consult-time">
          咨询时间：
          <span>{{ new Date(Number(createTime)).toLocaleString() }}</span>
        </div>
      </section> -->

      <three-evaluation
        :scores="scores"
        :greetings="greetings"
        :platform="platform"
        @refreshSelect="refreshSelect"
        @starClick="starClick"
        @inputBlur="inputBlur"
      ></three-evaluation>
    </section>

      <z-button-group>
        <z-button
        :disabled="!canSubmit"
        :text="btnText"
        class="rateHome-btn"
        size="large"
        type="primary"
        @click="submit"
        ></z-button>
      </z-button-group>
  </div>
</template>

<script>
import Vue from 'vue'
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { toast } from '../../native'
import { login, queryParams, getPlatform } from '../../lib/utils'
import { getQuestionnaireConfig, getEvaluateInfo, evaluateByStar } from '../../api/resourceApi'
// import JsonData from './data'
import ThreeEvaluation from '../KefuOrderEvaluation/ThreeEvaluation/Evaluation'
import { Button, ButtonGroup } from '@zz-common/zz-ui'
const btnConfig = getPlatform() === 'zlj' ? { v7: true } : { v8: true }
Vue.use(Button, btnConfig).use(ButtonGroup)

const query = queryParams()

export default {
  name: 'OfflineStarEvaluation',
  components: {
    ThreeEvaluation,
    'z-button': Button
  },
  data() {
    return {
      convId: query.convId || this.$route.query.convId,
      subConvId: query.subConvId || this.$route.query.subConvId,
      skillId: '',
      skillName: '',
      kefuUid: '',
      createTime: 0,
      commented: false,
      score: 0,
      greetings: '请问您对本次咨询是否满意？',
      scores: [],
      questionnaireId: '',
      curScores: {
        score: -1,
        content: '',
        optionIds: ''
      },
      waitCommit: false,
      isFocus: false,
      platform: native.client || 'zz' // 获取当前客户端平台，默认为转转
    }
  },
  computed: {
    btnText() {
      if (this.commented) {
        return this.platform === 'checkapp' ? '已收到您的评价！' : '小熊已收到您的评价！'
      }
      return '提交评价'
    },
    canSubmit() {
      return this.curScores.score > 0
    }
  },
  methods: {
    submit() {
      if (!this.canSubmit || this.commented) return
      if (this.curScores.content.length > 200) {
        toast({
          msg: '不能超过200字',
          style: '2'
        })
        return
      }
      if (this.commented) {
        toast({
          msg: '已经提交了哦',
          style: '1'
        })
        return
      }
      lego.send({
        pagetype: 'ZZUP_KEFU_STAR_EVALUATION',
        actiontype: 'SUBMIT_CLICK',
        backup: {
          convId: this.convId
        }
      })
      this.evaluateForm()
    },
    starClick(item) {
      lego.send({
        pagetype: 'ZZUP_KEFU_STAR_EVALUATION',
        actiontype: 'STAR_CLICK',
        backup: {
          convId: this.convId,
          score: item.score
        }
      })
    },
    optClick(item) {
      lego.send({
        pagetype: 'ZZUP_KEFU_STAR_EVALUATION',
        actiontype: 'OPT_CLICK',
        backup: {
          convId: this.convId,
          optname: item.name
        }
      })
    },
    refreshSelect(info) {
      this.curScores = Object.assign({}, info)
    },
    getEvaluateInfos() {
      return getEvaluateInfo({
        convId: this.convId
      }).then((data) => {
        this.skillId = data.skillId
        this.skillName = data.skillName
        this.createTime = data.createTime
        return data
      })
    },
    inputBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 150)
    },
    evaluateForm() {
      if (this.waitCommit) {
        return false
      }
      const params = {
        convId: this.convId,
        subConvId: this.subConvId,
        score: this.curScores.score,
        content: this.curScores.content,
        optionIds: this.curScores.optionIds,
        optionDesc: this.curScores.optionDesc,
        questionnaireId: this.questionnaireId,
        evaluateType: 5
      }
      this.waitCommit = true
      evaluateByStar(params).then((data) => {
        this.waitCommit = false
        if (+data.status === 0) {
          this.commented = true
          native.skipToUrl({
            targetUrl:
                'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html?pagetype=1#/orderevaluation/success',
            needClose: '1'
          })
        } else {
          toast({
            msg: data.msg || '出错啦',
            style: '1'
          })
        }
      })
    }
  },
  mounted() {
    login()
    native.setTitle({
      // title: '您有一个咨询未评价'
      title: '服务评价'
    })
    lego.send({
      pagetype: 'ZZUP_KEFU_STAR_EVALUATION',
      actiontype: 'PAGE_SHOW',
      backup: {
        convId: this.convId
      }
    })
    this.getEvaluateInfos().then((data) => {
      const params = {
        skillId: data.skillId,
        subConvId: this.subConvId // 辅助处理在线IM问卷内容异常，添加此字段
      }
      getQuestionnaireConfig(params).then((info) => {
        if (info.datas) {
          this.scores = info.datas
          this.questionnaireId = info.id
        }
      })
    })
  }
}
</script>
<style scoped lang="less">
  @import 'OfflineThreeEvaluation.less';
</style>
